import React from 'react'

const aStyle = { color: '#40c0c0' }

const TermsConditionsLabel = ({ toggleTerms }) => {
  return (
    <>
      <div className='flex items-center cursor-pointer'>
        <span className='ml-2 text-sm text-center font-medium'>Acepto los
          <span id='terms' className='font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer' style={aStyle} onClick={toggleTerms}> términos y condiciones</span>
        </span>
      </div>
    </>
  )
}

export default TermsConditionsLabel
